const SIGNER_OVERRIDE_FIELD_ID = "9d35b907-27da-47c5-98ab-faa2917c3f01";
const SIGNER_OVERRIDE_OWNER_OPTION_IDS = new Set([
  "7a75f1d1-7a16-41d5-bed9-01fa1fae3338",
  "81a69d31-9aae-492a-b40c-65a3e87b6694",
  "977f6b3f-3d7b-44ef-90bb-f3ea5a8a6ada",
]);
const SIGNER_OVERRIDE_CONTRACTOR_OPTION_ID =
  "74242fb6-42ff-462e-97ce-77c9b9869e62";

const normalizeCollection = (collection) => {
  if (Array.isArray(collection)) return collection;
  if (collection && typeof collection === "object") {
    return Object.values(collection);
  }
  return [];
};

const getDocumentFields = (document = {}) => {
  const fieldsContainer = document?.fields;
  const nestedFields =
    fieldsContainer && !Array.isArray(fieldsContainer)
      ? fieldsContainer?.fields
      : null;
  const flatFields = normalizeCollection(nestedFields || fieldsContainer);
  const sectionFields = normalizeCollection(document?.sections).flatMap(
    (section) => normalizeCollection(section?.fields),
  );

  return [...flatFields, ...sectionFields].filter(
    (field) => field && typeof field === "object" && !Array.isArray(field),
  );
};

const getSelectedOptionIds = (value) => {
  const values = Array.isArray(value) ? value : [value];
  return new Set(
    values
      .map((item) =>
        item && typeof item === "object"
          ? item.value || item.field_id || item.id
          : item,
      )
      .map((item) => String(item || "").trim())
      .filter(Boolean),
  );
};

export const getDocumentSignerOverride = (document) => {
  const signerField = getDocumentFields(document).find(
    (field) => field?.field_id === SIGNER_OVERRIDE_FIELD_ID,
  );
  if (!signerField) return null;

  const selectedIds = getSelectedOptionIds(signerField.value);
  if (selectedIds.has(SIGNER_OVERRIDE_CONTRACTOR_OPTION_ID)) {
    return "contractor";
  }
  if (
    [...SIGNER_OVERRIDE_OWNER_OPTION_IDS].some((optionId) =>
      selectedIds.has(optionId),
    )
  ) {
    return "owner";
  }
  return null;
};

export const getSignerOverrideToggleLocks = (
  selectedDocuments = [],
  documents = {},
) => {
  const hasSignerOverride = selectedDocuments.some((selectedDocument) => {
    const formId = selectedDocument?.form_id;
    return Boolean(formId && getDocumentSignerOverride(documents?.[formId]));
  });

  return {
    owner: hasSignerOverride,
    contractor: hasSignerOverride,
  };
};

export const getPartyRequirementDisplay = (doc, party) => {
  const currentParty = doc?.signatures?.[party] || {};

  if (currentParty.notary) {
    return { label: "Notarize", disabled: false };
  }

  if (currentParty.sign) {
    return { label: "Sign", disabled: false };
  }

  return { label: null, disabled: false };
};

export const hasPartyToggleableRequirements = (doc, party) => {
  const currentParty = doc?.signatures?.[party] || {};
  const originalParty = doc?.original_signatures?.[party] || {};

  return Boolean(
    currentParty.sign ||
      currentParty.notary ||
      originalParty.sign ||
      originalParty.notary,
  );
};

export const getDocumentSigningRequirements = (doc) => ({
  ownerSign: Boolean(doc?.signatures?.owner?.sign),
  ownerNotary: Boolean(doc?.signatures?.owner?.notary),
  contractorSign: Boolean(doc?.signatures?.contractor?.sign),
  contractorNotary: Boolean(doc?.signatures?.contractor?.notary),
});
